
import { createApiClient } from 'Network/ApiClient';
  
export const RelationAddAgeAndGenderAxiosInstance = createApiClient('IcdAgeGender/');


